import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getContacts } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class generalContacts extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              contacts: [],
              openedAdd:false
        };

        this.getContacts();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_school', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });

 

    }

    saveContact  = () => {

      alert("Saved");

    }

    getContacts = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getContacts(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            contacts: res.data
            
          });
        } else {
          this.setState({
            contacts: [],
          });
        }
      });
    }    

    render() {

        const { contacts } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Contacts</h4>
                 

                  <div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Sitename </label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='site_name' className='form-control' type='text' value={contacts.site_name}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> EmailID </label>
                        </div>
                        <div class="form-group col-md-9">
                           <input name='emailid' className='form-control' type='text' value={contacts.emailid}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Address</label>
                        </div>
                        <div class="form-group col-md-9">
                           <textarea name='address' className='form-control' type='text' value={contacts.address}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>


                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Mobilenumber </label>
                        </div>
                        <div class="form-group col-md-9">
                           <input name='mobilenumber' className='form-control' type='text' value={contacts.mobilenumber}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>

                       <div className="row mb-4 text-right">
                          <button type='submit' id="btnSubmit"
                            className="btn btn-primary btn-sm" onClick={this.saveContact} disabled={this.state.btnDisable} style={{ display: "block", margin: "auto" }}>
                            Submit
                          </button>
                        </div>

                    </div>
                      
                    
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default generalContacts;


// WEBPACK FOOTER //
// ./src/components/bewise/generalContacts.jsx